// extracted by mini-css-extract-plugin
export var actionButton = "_k7-0";
export var fileInput = "_k7-2";
export var paperclip = "_k7-1";